<template>
  <v-layout v-if="$route.query.id" row wrap justify-center>
    <template v-if="processing">
      <div class="layout align-center column" style="padding: 200px 0">
        <div class="subheading">Sedang menyiapkan data terkait...</div>
        <v-progress-linear style="width: 50%" color="primary" indeterminate>
        </v-progress-linear>
      </div>
    </template>
    <template v-else>
      <v-flex sm12 md11 lg10>
        <v-card>
          <v-card-title class="subheading py-2"
            >DETAIL {{ title }}</v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <slot name="detail-content" :detail="detail"> </slot>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-speed-dial
        v-if="fab && profil.role != 'DIREKSI'"
        v-model="fab_state"
        fixed
        bottom
        right
        direction="left"
        transition="slide-x-reverse-transition"
      >
        <v-btn
          slot="activator"
          v-model="fab_state"
          color="indigo darken-2"
          dark
          fab
        >
          <v-icon>apps</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
        <v-btn
          v-if="fabEditDelete"
          fab
          dark
          small
          @click.stop="onUpdate"
          color="blue"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn fab dark small @click.stop="onAdd" color="green">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="fabEditDelete"
          fab
          dark
          small
          @click.stop="onDelete"
          color="red"
        >
          <v-icon>delete</v-icon>
        </v-btn>
      </v-speed-dial>
    </template>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "pg-detail",
  props: {
    title: {
      type: String,
      default: ""
    },
    primary_key: {
      type: String,
      default: ""
    },
    primary_field: {
      type: String,
      default: ""
    },
    fab: {
      type: Boolean,
      default: true
    },
    checkCreator: {
      type: Boolean,
      default: false
    },
    deleteProcess: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      fab_state: false,
      processing: true,
      fabEditDelete: true
    };
  },
  computed: {
    ...mapState("auth", ["profil"]),
    detail() {
      let result = null;
      if (
        this.$route.query.id &&
        this.$store.state[this.primary_field][`${this.primary_field}_loaded`]
      ) {
        result = this.$store.getters[
          `${this.primary_field}/${this.primary_field}Injected`
        ].find(src => {
          return src[this.primary_key] == this.$route.query.id;
        });
      }
      return result;
    }
  },
  methods: {
    onUpdate() {
      this.fab_state = false;
      this.$emit("update");
    },
    onAdd() {
      this.fab_state = false;
      this.$emit("add");
    },
    onDelete() {
      this.fab_state = false;
      this.$emit("delete");
    }
  },
  watch: {
    detail: {
      handler(val) {
        if (val) {
          if (this.checkCreator) {
            if (
              val.id_user == this.profil.id_user ||
              this.profil.role == "ADMIN"
            ) {
              this.fabEditDelete = true;
            } else {
              this.fabEditDelete = false;
            }
          }
          this.fab_state = false;
          this.processing = false;
          this.$emit("found", this.detail);
        } else {
          if (!this.deleteProcess) {
            if (
              this.$store.state[this.primary_field][
                `${this.primary_field}_loaded`
              ]
            ) {
              if (
                this.primary_field == this.$route.meta.primary_field &&
                this.$route.query.id
              ) {
                this.$router.push({
                  name: "NotFound"
                });
              }
            }
          }
          this.processing = true;
        }
      },
      immediate: true
    }
  }
};
</script>
